import { render, staticRenderFns } from "./depositItem.vue?vue&type=template&id=2deab4f1&scoped=true&"
import script from "./depositItem.vue?vue&type=script&lang=js&"
export * from "./depositItem.vue?vue&type=script&lang=js&"
import style0 from "./depositItem.vue?vue&type=style&index=0&id=2deab4f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deab4f1",
  null
  
)

export default component.exports